import {Injectable} from '@angular/core';

@Injectable()
export class LocalStorageService {

  pathName: string;

  setPathName(pathName: string) {
    if (pathName) {
      this.pathName = pathName.replace(/^\/|\/$/g, '');
    } else {
      this.pathName = pathName;
    }
  }


  getPathName() {
    if (this.pathName)    {
      return this.pathName;
    }
    return '';
  }

  remove(pre: boolean, key: string) {
    let aKey = key;
    if (pre) {
      aKey = this.pathName ? this.pathName + key : key;
    }
    (window as any).localStorage.removeItem(aKey);
  }


  save(pre: boolean, key: string, data: any) {
    let aKey = key;
    if (pre) {
      aKey = this.pathName ? this.pathName + key :  key;
    }
    if (typeof data === 'object') {
      (window as any).localStorage.setItem(aKey, JSON.stringify(data));
    } else {
      (window as any).localStorage.setItem(aKey, data);
    }
  }

  load(pre: boolean, key: string) {
    let aKey = key;
    if (pre) {
      aKey = this.pathName ? this.pathName + key :  key;
    }

    const data = (window as any).localStorage.getItem(aKey);
    if (typeof data === 'string') {
      try {
        return JSON.parse(data);
      } catch (e) {
        return data;
      }
    } else {
      return data;
    }
  }

  public getPrivilege(privilege: string, key: string) {
    const val = localStorage.getItem(key);
    if (!val) {
      return false;
    }
    const privileges = JSON.parse(val).privileges;
    if (privileges) {
      const list = privileges.filter(p => p.id.toLowerCase().includes(privilege));
      return list.length > 0;
    }
    return false;
  }

  /**
   * Удаляет из JSON-объекта, хранящегося в localStorage под ключом `key`, поле `fieldName`.
   * Если объект невалидный или поля нет — ничего не делает.
   * @param pre — нужно ли автоматически добавлять префикс pathName
   * @param key — ключ в localStorage (без учёта префикса, если pre=true)
   * @param fieldName — имя свойства, которое нужно удалить из сохранённого объекта
   */
  clearField(pre: boolean, key: string, fieldName: string): void {
    // Считываем текущее значение (оно либо объект, либо примитив, либо null)
    const raw = this.load(pre, key);
    if (raw && typeof raw === 'object') {
      // Если это объект и в нём есть нужное поле — удаляем
      if (Object.prototype.hasOwnProperty.call(raw, fieldName)) {
        delete (raw as any)[fieldName];
        // Сохраняем обратно обновлённый объект
        this.save(pre, key, raw);
      }
    }
    // Во всех иных случаях — ничего не трогаем
  }

}
